import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLink from '../../../../library/form/components/FormLink';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormWrapper from '../../../../library/form/components/FormWrapper';

const BudgetActionRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <ul className="uiDPEditLine">
            <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "sheetId" }}
                customWrapper="li" wrapperClass="uiColumnCenter uiColumn100">
                <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "sheetId" }} />
            </FormWrapper>
            <li className="uiColumnCenter uiColumn100">
                <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                    action={{
                        paramName: "targetDoc",
                        actionId: "show", containerKey: "popup"
                    }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actualQty" }} />
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormButton formObject={formObject} rowKey={rowKey} className=""
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    action={{ actionId: "del", actionParam: {}, containerKey: "row" }}
                />
            </li>
        </ul>
    )
}

export default BudgetActionRow
